import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Seo from "../../seo";
import { api, formatApiError } from "../../api";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError(""); setLoading(true);
        try {
            await api.post("/auth/login", { email, password });
            navigate("/admin/dashboard");
        } catch (err) {
            setError(formatApiError(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    const inputCls = "w-full rounded-lg border border-input bg-white px-4 py-3 text-sm text-navy focus:outline-none focus:ring-2 focus:ring-accent";

    return (
        <div className="flex min-h-screen items-center justify-center bg-mist px-5">
            <Seo title="Admin Login | Dr. Krishnakanth AVB" description="Admin area." />
            <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-border bg-white p-8" data-testid="admin-login-form">
                <p className="font-mono-label text-steel">Admin</p>
                <h1 className="mt-2 font-display text-2xl font-medium text-navy">Sign in</h1>
                <div className="mt-7 space-y-4">
                    <div>
                        <label htmlFor="admin-email" className="mb-1.5 block text-xs font-semibold text-navy">Email</label>
                        <input id="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                            className={inputCls} data-testid="admin-email-input" autoComplete="username" />
                    </div>
                    <div>
                        <label htmlFor="admin-password" className="mb-1.5 block text-xs font-semibold text-navy">Password</label>
                        <input id="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                            className={inputCls} data-testid="admin-password-input" autoComplete="current-password" />
                    </div>
                </div>
                {error && <p className="mt-4 text-sm font-medium text-red-600" data-testid="admin-login-error">{error}</p>}
                <button type="submit" disabled={loading} data-testid="admin-login-submit-btn"
                    className="mt-7 w-full rounded-full bg-navy px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-accent disabled:opacity-60">
                    {loading ? "Signing in…" : "Sign in"}
                </button>
            </form>
        </div>
    );
}
